import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { icon } from 'src/consts/icon';

@Component({
  selector: 'app-model-header',
  templateUrl: './model-header.component.html',
  styleUrls: ['./model-header.component.scss'],
  imports: [CommonModule, MatIconModule, MatButtonModule]
})
export class ModelHeaderComponent {
  @Input() title!: string;
  @Output() dialogClose = new EventEmitter();
  invoice_logo: any = icon.INVOICE_LOGO;

  constructor() {
    let logo = localStorage.getItem("smartaccupay-logo") as string;
    if (logo) {
      this.invoice_logo = logo;
    }
  }

}
